import { css } from 'vue-styled-components';
import { SUBSCRIPTION_STATUS } from '@consts';

import { notEq, addIdUnless } from '@util';

export default {
    namespaced: true,
    state: {
        isLogoutModalActive: false,
        isLoadingAdriel: false,
        loadingMsg: '',
        isNewCampaignModalActive: false,
        windowDimension: {},
        toastMessage: '',
        toastIsError: false,
        isSubscriptionModalActive: false,
        toastStyle: css``,
        toastTimer: null,
        toastPosition: undefined,
        currencyModalVisible: false,
        notiMsgs: [],
        showCsmToast: false,
        snackbarSafeBottom: null,
        // Set once a forced sign-out starts (the session is gone, e.g. an MFA
        // reset from Back Office). Leave guards stand down for it.
        isForcingLogout: false,
    },
    mutations: {
        setLogoutModalActive(state, value) {
            state.isLogoutModalActive = value;
        },
        setIsForcingLogout(state, value) {
            state.isForcingLogout = value;
        },
        setLoadingAdrielActive(state, value) {
            state.isLoadingAdriel = value;
        },
        setIsNewCampaignModalActive(state, value) {
            state.isNewCampaignModalActive = value;
        },
        setLoadingMsg(state, value) {
            state.loadingMsg = value;
        },
        setDemoAccountModalActive(state, value) {
            state.isDemoAccountModalActive = value;
        },
        setWindowDimension(state, value = {}) {
            if (notEq(value, state.windowDimension)) {
                state.windowDimension = Object.freeze(value);
            }

            // VTooltip.enabled = value.width > 800;
        },
        setToast(
            state,
            { message, time, isError = false, style, position: toastPosition }
        ) {
            Object.assign(state, {
                toastStyle: style,
                toastIsError: isError,
                toastMessage: message,
                toastPosition,
            });

            state.toastTimer && clearTimeout(state.toastTimer);

            state.toastTimer = setTimeout(() => {
                Object.assign(state, {
                    toastStyle: undefined,
                    toastMessage: '',
                    toastIsError: false,
                    toastPosition: undefined,
                });
            }, time || 5000);
        },
        setIsSubscriptionModalActive(state, value) {
            state.isSubscriptionModalActive = value;
        },
        setVisibleTo(state, { key, value } = {}) {
            state[key] = value;
        },
        setNotiMsgs(state, values = []) {
            state.notiMsgs = R.map(addIdUnless, values);
        },
        addNotiMsg(state, noti = {}) {
            state.notiMsgs = [addIdUnless(noti), ...state.notiMsgs];
        },
        replaceNotiMsg(state, newNoti = {}) {
            const { targetId } = newNoti;

            if (!targetId) return;

            // if (newNoti.id == undefined) {
            //     newNoti = R.assoc('id', targetId, newNoti);
            // }

            const idx = R.findIndex(R.propEq('id', targetId), state.notiMsgs);

            if (idx === -1) {
                state.notiMsgs = R.prepend(addIdUnless(newNoti), state.notiMsg);
            } else {
                state.notiMsgs = R.update(
                    idx,
                    addIdUnless(newNoti),
                    state.notiMsgs
                );
            }
        },
        removeNotiMsg(state, { id } = {}) {
            if (!id) return;

            state.notiMsgs = R.filter(
                R.complement(R.propEq('id', id)),
                state.notiMsgs
            );
        },
        setShowCsmToast(state, value) {
            state.showCsmToast = value;
        },
        setSnackbarSafeBottom(state, value) {
            state.snackbarSafeBottom = value;
        },
    },
    actions: {
        setLoadingAdriel({ commit }, { active, message }) {
            commit('setLoadingAdrielActive', active);
            commit('setLoadingMsg', message);
        },
    },
    getters: {
        isLogoutModalActive: R.prop('isLogoutModalActive'),
        isLoadingAdriel: R.prop('isLoadingAdriel'),
        isNewCampaignModalActive: R.prop('isNewCampaignModalActive'),
        loadingMsg: R.prop('loadingMsg'),
        windowDimension: R.propOr({ width: 0, height: 0 }, 'windowDimension'),
        toastMessage: R.prop('toastMessage'),
        toastIsError: R.prop('toastIsError'),
        subscriptionWarningVisible: R.compose(
            R.equals(SUBSCRIPTION_STATUS.ENDED),
            R.prop('user/subscriptionStatus'),
            R.nthArg(3)
        ),
        notiMsgs: R.compose(R.prop('notiMsgs'), R.nthArg(0)),
        showCsmToast: R.prop('showCsmToast'),
        snackbarSafeBottom: R.prop('snackbarSafeBottom'),
    },
};
